import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-surface border-t border-border">
      <div className="mx-auto max-w-5xl px-5 py-10">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <div className="flex h-7 w-7 items-center justify-center rounded-md bg-primary">
                <i className="ri-ticket-line text-white text-[14px]" />
              </div>
              <span className="text-[15px] font-semibold tracking-tight text-ink">
                e-vignette
              </span>
            </div>
            <p className="mt-3 max-w-xs text-[13px] leading-[1.55] text-muted">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <div className="mb-3 text-[12px] font-semibold uppercase tracking-wider text-muted">
              {t('footer.service.title')}
            </div>
            <ul className="space-y-2 text-[13px]">
              <li><a href="/#countries" className="text-ink-soft hover:text-primary transition">{t('footer.service.allCountries')}</a></li>
              <li><Link to="/blog" className="text-ink-soft hover:text-primary transition">{t('footer.service.blog')}</Link></li>
              <li><Link to="/contact" className="text-ink-soft hover:text-primary transition">{t('footer.service.contact')}</Link></li>
            </ul>
          </div>

          <div>
            <div className="mb-3 text-[12px] font-semibold uppercase tracking-wider text-muted">
              {t('footer.legal.title')}
            </div>
            <ul className="space-y-2 text-[13px]">
              <li><Link to="/terms" className="text-ink-soft hover:text-primary transition">{t('footer.legal.termsOfUse')}</Link></li>
              <li><Link to="/privacy" className="text-ink-soft hover:text-primary transition">{t('footer.legal.privacyPolicy')}</Link></li>
              <li><Link to="/refund" className="text-ink-soft hover:text-primary transition">{t('footer.legal.refundPolicy')}</Link></li>
              <li><Link to="/cookies" className="text-ink-soft hover:text-primary transition">{t('footer.legal.cookiePolicy')}</Link></li>
            </ul>
          </div>

          <div>
            <div className="mb-3 text-[12px] font-semibold uppercase tracking-wider text-muted">
              {t('footer.support')}
            </div>
            <ul className="space-y-2 text-[13px]">
              <li>
                <a href="mailto:support@lead-pixel-labs.com" className="text-ink-soft hover:text-primary transition">
                  support@lead-pixel-labs.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-border pt-5 text-[12px] text-muted flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <span>© 2026 e-vignette. {t('footer.rights')}</span>
          <span className="text-muted/70">LeadPixel Labs LLC, 30 North Gould Street, Ste R, Sheridan, WY 82801, US</span>
        </div>
      </div>
    </footer>
  );
}
